export enum AuthenticationErrorCodes {
  //indicate when the user doesn't have the access permissions
  AccessDeniedError = 1
}
